module.exports = __webpack_public_path__ + "img/webBrand--billy-dash-dk.ff3809db.svg";